"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const SvgCert = props => (0, jsx_runtime_1.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 53,
  height: 26,
  ...props,
  children: (0, jsx_runtime_1.jsx)("text", {
    transform: "translate(0 21)",
    fontSize: 20,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700,
    children: (0, jsx_runtime_1.jsx)("tspan", {
      x: 0,
      y: 0,
      children: 'CERT.'
    })
  })
});
exports.default = SvgCert;